import getFilterRelationKeys from './get-filter-relation-keys';
import { ID } from '../constants';
const getFilterLocalKeys = (relationName, relations) => {
  const {
    entityIdentifier
  } = relations.find(({
    localField
  }) => localField === relationName) || {};
  return entityIdentifier;
};
const getRelationEntity = (filterName, filterEntityRelations) => {
  const {
    entityIdentifier
  } = filterEntityRelations.find(({
    foreignKey
  }) => foreignKey === filterName) || {};
  return entityIdentifier;
};
const getFilterProps = (filter, {
  relations: currentEntityRelations = [],
  properties: currentEntityProperties = {},
  dynamicProperties: currentEntityDynamicProperties = {},
  identifier: currentEntityId
} = {}, {
  relations: filterEntityRelations = [],
  identifier: filteryEntityId
} = {}) => {
  const [filterName] = filter.split('/');
  let [relationName, relationProp] = filterName.split('.');
  if (filterName === ID) {
    const idRelation = currentEntityRelations.find(({
      entityIdentifier
    }) => entityIdentifier === filteryEntityId);
    if (idRelation) {
      relationName = idRelation.foreignKey;
    }
  }
  const hasProperty = !!(currentEntityProperties[filterName] || currentEntityDynamicProperties[filterName]);
  const relationEntityName = relationProp ? getFilterLocalKeys(relationName, currentEntityRelations) : null;
  const filterNameEntity = getRelationEntity(filterName, filterEntityRelations);
  const propertyEntityName = relationEntityName || filterNameEntity;
  const entityName = filterNameEntity ? filteryEntityId : relationEntityName;
  const isEntityItself = currentEntityId === propertyEntityName;
  const shouldCheckRelationNames = !hasProperty && !relationEntityName;
  const relationForeignKeys = shouldCheckRelationNames ? getFilterRelationKeys(propertyEntityName, currentEntityRelations, currentEntityProperties) : [];
  const shouldIgnoreFilter = shouldCheckRelationNames && !relationForeignKeys.length;
  return {
    filterName,
    entityName,
    relationName,
    relationProp,
    hasProperty,
    relationEntityName,
    isEntityItself,
    relationForeignKeys,
    shouldIgnoreFilter
  };
};
export default getFilterProps;
//# sourceMappingURL=get-filter-props.js.map